export const createSlug = (text: string) => {
  const normalizedText = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return normalizedText.toLowerCase().replace(/\s+/g, '-');
};
